import firebase from 'firebase/app';
import 'firebase/storage';

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCcSJeEPfEqHrYdj6xmgS-bn2PWZ3m7fJs",
  authDomain: "simple-notes-firebase-19ec6.firebaseapp.com",
  databaseURL: "https://simple-notes-firebase-19ec6.firebaseio.com",
  projectId: "simple-notes-firebase-19ec6",
  storageBucket: "simple-notes-firebase-19ec6.appspot.com",
  messagingSenderId: "825351377337",
  appId: "1:825351377337:web:3c5e428daa2f12e1a06668",
  measurementId: "G-3TJY2XRFWP"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// initial storage firebase to react app
const storage = firebase.storage();

export {
  storage, firebase as default
}



// WEBPACK FOOTER //
// ./src/firebase/index.js